import SubjectCodeSearchModal from '../../modal/SubjectCodeSearchModal';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import SearchInputBox from '../../../component/SearchInputBox';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import TableBox from '../../../component/TableBox';
import { useDispatch, useSelector } from 'react-redux';
import { defaultGridData, handleControl, initGrid } from '../../../module/component/TableBoxModule';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { actionStudentSearch } from '../../../module/body/sms/SmsSendModule';
import qs from 'qs';
import { Tooltip, IconButton } from '@material-ui/core';
import AddIcon from '../../../component/icon/AddIcon';
import SelectionBox from '../../../component/SelectionBox';
import CodeUtil from '../../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import InputBox from '../../../component/InputBox';
import NullCheckUtil from '../../../util/NullCheckUtil';
import FormatUtil from '../../../util/FormatUtil';
import { actionSetPhoneData, actionExcelDownload } from '../../../module/body/sms/SmsSendModule';
import PathUtil from '../../../util/PathUtil';
import { useLocation } from 'react-router-dom';

// --------------------------------------------------------------
//  사용자 검색 부분
//  - Grid 의 수신번호 추가를 제외하면 독립적인 기능으로 봐도 됨
// --------------------------------------------------------------
const SmsSendUserSearchView = ({ modalRef, popupRef }) => {
    const dispatch = useDispatch();
    const location = useLocation();

    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });

    const [semesterId, setSemesterId] = useState('');
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const [userNm, setUserNm] = useState('');

    const [lessonUniversityCd, setLessonUniversityCd] = useState('');
    const [subjectId, setSubjectId] = useState('');
    const [subjectNm, setSubjectNm] = useState('');
    const [classNo, setClassNo] = useState('');

    const [params, setParams] = useState({});
    const { gridData } = useSelector((state) => state.tableBoxState);
    const { phoneData } = useSelector((state) => state.smsSendState);

    // 최초 조회
    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onChangePageInfo,
                onRowDoubleClick,
                params,
            }),
        );

        queryData.semesterId && setSemesterId(queryData.semesterId);
        queryData.userUniversityCd && setUserUniversityCd(queryData.userUniversityCd);
        queryData.userNm && setUserNm(queryData.userNm);
        queryData.lessonUniversityCd && setLessonUniversityCd(queryData.lessonUniversityCd);
        queryData.subjectId && setSubjectId(queryData.subjectId);
        queryData.classNo && setClassNo(queryData.classNo);

        onClickSearch({
            semesterId: queryData.semesterId,
            userUniversityCd: queryData.userUniversityCd,
            userNm: queryData.userNm,
            lessonUniversityCd: queryData.lessonUniversityCd,
            subjectId: queryData.subjectId,
            classNo: queryData.classNo,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 10,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onChangePageInfo,
                onRowDoubleClick,
                params,
            }),
        );
    }, [params, phoneData]);

    // 수신번호 추가
    const handleAddPhone = useCallback(
        (phone) => {
            console.log('* handleAddPhone : ' + phone);
            console.log('* 등록된 번호 목록 : ' + phoneData);

            if (NullCheckUtil.isEmpty(phone) || phone.length != 11) {
                popupRef.current.openAlert('올바른 번호를 입력하세요.');
                return;
            }

            const isDuplicate = phoneData.some((item) => item == phone);

            if (isDuplicate) {
                console.log('* isDuplicate : ' + isDuplicate);
                popupRef.current.openAlert('이미 등록된 번호입니다.');
            } else {
                dispatch(
                    actionSetPhoneData({
                        data: {
                            job: 'add',
                            phone,
                        },
                    }),
                );
            }
        },
        [phoneData],
    );

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };

    const onClickSearch = (params) => {
        console.log('onClickSearch');
        setParams(params);
        dispatch(
            actionStudentSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, params);
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                semesterId,
                userUniversityCd,
                userNm,
                lessonUniversityCd,
                subjectId,
                classNo,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    // 사용자 검색결과 EXCEL 다운로드
    const handleDownload = () => {
        console.log('handleDownload');
        dispatch(actionExcelDownload({ params }));
    };

    const onRowDoubleClick = () => {};

    // 과목 조회 모달 OPEN
    const onClickSubjectNm = (e) => {
        modalRef.current.open(
            <SubjectCodeSearchModal
                callback={(subjectId, subjectNm) => {
                    setSubjectId(subjectId);
                    setSubjectNm(subjectNm);
                }}
                modalRef={modalRef}
            />,
            'large',
        );
    };

    const columns = useMemo(
        () => [
            {
                field: 'userUniversityCd',
                headerName: '소속대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, params.row.userUniversityCd),
            },
            {
                field: 'userNm',
                headerName: '이름',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userId',
                headerName: '사용자ID',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
            },
            {
                field: 'telNo',
                headerName: '연락처',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => FormatUtil.phoneFormatter(params.row.telNo),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 5,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title={'추가'}>
                            <IconButton onClick={(e) => handleAddPhone(item.row.telNo)}>
                                <AddIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [phoneData],
    );

    return (
        <>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => setSemesterId(e.target.value)}
                                    useAll={true}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='소속대학'
                                    w140
                                    value={userUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                    onChange={(e) => setUserUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='이름'
                                    size='medium'
                                    value={userNm}
                                    onChange={(e) => setUserNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                    maxLength='4'
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) => {
                                        onClickSearch({
                                            semesterId,
                                            userUniversityCd,
                                            userNm,
                                            lessonUniversityCd,
                                            subjectId,
                                            classNo,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='board-row'>
                        <div className='lec-check-box mt16'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='개설대학'
                                    w140
                                    value={lessonUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    onChange={(e) => setLessonUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SearchInputBox
                                    title='교과목'
                                    size='large'
                                    value={subjectNm}
                                    onClick={(e) => onClickSubjectNm(e)}
                                />
                                <InputBox
                                    title='분반'
                                    size='small'
                                    value={classNo}
                                    onChange={(e) => setClassNo(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                    maxLength='4'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='con-tb-title'>
                <h3 className='tb-tit-name'>수신자(학생) 검색결과</h3>
                <div className='btn-group'>
                    <ExcelDownloadButtonBox onClick={(e) => handleDownload()} />
                </div>
            </div>
            <div className='comment-box'>
                <ul>
                    <li>그리드의 추가 버튼을 이용하여 검색된 학생을 수신자에 추가할 수 있습니다. </li>
                    <li>일괄 등록이 필요한 경우 엑셀을 다운로드 받아 상단의 엑셀 업로드를 이용하여 일괄 등록하세요.</li>
                </ul>
            </div>
            <TableBox isSupportedWide={false} />
        </>
    );
};

export default SmsSendUserSearchView;
